import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {CanActivate} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {isPlatformServer} from '@angular/common';
import {AreaRiservataService} from "./services/area-riservata.service";

@Injectable({ providedIn: 'root' })
export class AuthGuardKeyCloak implements CanActivate {

  constructor(
    private keycloak: KeycloakService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private areaRiservataService: AreaRiservataService
  ) {}

  async canActivate(): Promise<boolean> {

    // 🔥 SSR MODE: NEVER try to authenticate
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    // 🔥 Browser mode
    const loggedIn = await this.keycloak.isLoggedIn();
    //this.areaRiservataService.getIsMFAActive(
    if (!loggedIn && this.areaRiservataService.getIsMFAActive()) {
      // Keycloak JS login flow in browser only
      this.keycloak.login();
      return false;
    }

    return true;
  }
}
